export enum LayoutMode {
  Hidden = 'hidden',
  ProjectDesign = 'projectDesign',
  SourceCode = 'sourceCode',
  TPM = 'tpm'
}
